import { Separator } from '@volue/wave-react';
import React from 'react';

import { useAppState } from '@/overmind';
import type { SidebarState } from '@/overmind/namespaces/sidebar';

import { ApplicationVersionSection } from './ApplicationVersion/ApplicationVersionSection';
import { CollapseButton } from './components/CollapseButton';
import { LinkNavItem } from './components/LinkNavItem';
import { LogoTitle } from './components/LogoTitle';
import { Organization } from './components/Organization';
import { TenantPicker } from './components/TenantPicker';
import { User } from './components/User';
import { useSidebarState } from './hooks/useSidebarState.hook';

function getSidebarClass(state: SidebarState) {
  switch (state) {
    case 'Uncollapsed':
    case 'PopupOpen':
      return 'sidebarNav-uncollapsed';
    case 'Collapsed':
      return 'sidebarNav-collapsed';
    default:
      return '';
  }
}

export function Navigation() {
  const router = useAppState().router;
  const [sidebarState, toggleSidebar] = useSidebarState();
  const hasConfigApiAccess = useAppState().hasConfigApiAccess;

  const sidebarClass = getSidebarClass(sidebarState);

  return (
    <div className={`vh100 dF ${sidebarClass}`}>
      <aside className="sidebarNav sidebarNav--withTransition elevationXs fg1 z4">
        <header className="sidebarNav-header">
          <div className="sidebarNav-headerTop white">
            <div className="sidebarNav-headerTopWrapper maw100 dF aiC">
              <button
                className="white sidebarNav-headerOpen js-sidebarNav-headerOpen dF aiC jcC"
                onClick={() => toggleSidebar(true)}
              >
                <span className="svgIcon svgIcon--stroked">
                  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path d="M3 18h18m0-6H3m0-6h18" />
                  </svg>
                </span>
              </button>

              <LogoTitle />
              <button
                className="white sidebarNav-headerClose js-sidebarNav-headerClose dF aiC jcC mRs"
                onClick={() => toggleSidebar(false)}
              >
                <span className="svgIcon svgIcon--stroked">
                  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path d="M6 18 18 6M6 6l12 12" />
                  </svg>
                </span>
              </button>
            </div>
          </div>
          <Organization />
        </header>
        <div className="sidebarNav-menuContent ofH ofyA themedScrollbar fg1">
          <nav className="mVs">
            <ul className="bareList">
              <li>
                <TenantPicker />
              </li>
              <li>
                <Separator />
              </li>
              <li>
                <LinkNavItem
                  label="Dashboard"
                  link={{ page: 'root' }}
                  iconName="layout"
                  isSelected={
                    router.current === 'VALID_PAGE' &&
                    router.currentRoute !== 'configurationV2'
                  }
                />
              </li>
              {hasConfigApiAccess && (
                <li>
                  <LinkNavItem
                    label="Configuration (config-api)"
                    link={{ page: 'configurationV2' }}
                    iconName="settings"
                    isSelected={
                      router.current === 'VALID_PAGE' &&
                      router.currentRoute === 'configurationV2'
                    }
                  />
                </li>
              )}
            </ul>
          </nav>
        </div>
        <nav className="sidebarNav-fixedMenuContent mVs">
          <div className="sidebarNav-groupHeader">{'Profile'}</div>
          <nav>
            <ul className="bareList">
              <li className="sidebarNav-userAndCollapse dF aiC jcSB">
                <User />
                <CollapseButton onClick={() => toggleSidebar()} />
              </li>
            </ul>
          </nav>
          <ApplicationVersionSection isVisible={sidebarState !== 'Collapsed'} />
        </nav>
      </aside>
    </div>
  );
}
